<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Home from './Index/layout.vue'
import FlowerList from './FlowerList/main.vue'
import ActRules from './ActRules/main.vue'

import Qna from './Qna/main.vue'
import act from './Qna/act.vue'
import brand from './Qna/brand.vue'
import diamond from './Qna/diamond.vue'
import lottery from './Qna/lottery.vue'
import pot from './Qna/pot.vue'
import report from './Qna/report.vue'
import notice from './Qna/notice.vue'

import Product from './Index/ProductIntro.vue'

import VueAnalytics from 'vue-analytics'









Vue.use(VueRouter); //vue router 必加



const router = new VueRouter({
    //scrollBehavior,

    routes: [
        {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Home,
                    name: 'index',
                    meta: {
                        title: '德國雙人鑄鐵工藝',
                        trackedTitle: '德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'brand-intro',
                    component: Home,
                    name: 'brand-intro',
                    meta: {
                        title: '品牌介紹-德國雙人鑄鐵工藝',
                        trackedTitle: '品牌介紹-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'product-intro',
                    component: Home,
                    name: 'product-intro',
                    meta: {
                        title: '商品介紹-德國雙人鑄鐵工藝',
                        trackedTitle: '商品介紹-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'flower-list',
                    component: Home,
                    name: 'flower-list',
                    meta: {
                        title: '印花攻略-德國雙人鑄鐵工藝',
                        trackedTitle: '印花攻略-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'FlowerList/:id?',
                    component: FlowerList,
                    name: 'flower-list-inner',
                    props: true,
                    meta: {
                        title: '印花攻略-德國雙人鑄鐵工藝',
                        trackedTitle: '印花攻略-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'card-download',
                    component: Home,
                    name: 'card-download',
                    meta: {
                        title: '收集卡下載-德國雙人鑄鐵工藝',
                        trackedTitle: '收集卡下載-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'ActRules',
                    component: ActRules,
                    meta: {
                        title: '活動辦法-德國雙人鑄鐵工藝',
                        trackedTitle: '活動辦法-德國雙人鑄鐵工藝'
                    }
                },
                {
                    path: 'Qna',
                    component: Qna,
                    meta: {
                        title: '常見問題-德國雙人鑄鐵工藝',
                        trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                        secure: false
                    },
                    props: true,
                    children: [
                        {name: 'act', path: "act", component: act, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {name: 'brand', path: "brand", component: brand,  meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {name: 'report', path: "report", component: report, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {name: 'pot', path: "pot", component: pot, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {name: 'diamond', path: "diamond", component: diamond, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {name: 'lottery', path: "lottery", component: lottery, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }},
                        {
                            name: 'notice', 
                            path: "notice/:id?", 
                            component: notice, 
                            props: true, 
                            meta: {
                                title: '常見問題-德國雙人鑄鐵工藝',
                                secure: false,
                                trackedTitle: '常見問題-德國雙人鑄鐵工藝'
                            }
                        },
                        {path: "", component: act, meta: {
                            title: '常見問題-德國雙人鑄鐵工藝',
                            trackedTitle: '常見問題-德國雙人鑄鐵工藝',
                            secure: false
                        }}
                    ]
                },
                {
                    path: 'product/:id',
                    component: Product,
                    name: 'product',
                    props: true,
                    meta: {
                        title: '德國雙人鑄鐵工藝',
                        trackedTitle: '德國雙人鑄鐵工藝',
                        secure: false
                    }
                },
                {
                    path: '*',
                    redirect: '/',
                    //也可以用{name: xxx}
                }
            ]
        }
    ]
    
    

});


Vue.use(VueAnalytics, {
    id: 'UA-125507822-7',
    router,
    autoTracking: {
        pageviewOnLoad: false
    }
})

router.beforeEach((to, from, next) => {

    console.log(to)    

    if(to.name === 'product') {
        let id = JSON.parse(to.params.id);
        switch (id) {
            case 0:
                document.title = '矽膠鍋鏟';
                break;
            case 1:
                document.title = '隔熱手套1副';
                break;
            case 2:
                document.title = '陶瓷雙色碗2件組';
                break;
            case 3:
                document.title = '陶瓷烤盅附蓋2件組';
                break;
            case 4:
                document.title = '陶瓷雙色烤盤30x21cm';
                break;
            case 5:
                document.title = '琺瑯鑄鐵圓鍋24cm';
                break;
            case 6:
                document.title = '琺瑯鑄鐵橢圓鍋29cm';
                break;
        }

        document.title += '-' + to.meta.title;
    } else {
        document.title = to.meta.title
    }


    
    

    next();
});


// Vue.use(VueAnalytics, {
//     id: 'UA-125507822-6',
//     router,
//     autoTracking: {
//         exception: true,
//         shouldRouterUpdate (to, from) {
//         // next route path is not the same as the previous
//         return to.path !== from.path
//         }

//     }
// })


export default router;




</script>


// WEBPACK FOOTER //
// src/router.vue